import React from 'react';
import SendIcon from '@mui/icons-material/Send';

const IMG = {
  hero: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=2653&auto=format&fit=crop',
};

const HomeNewsletter: React.FC = () => (
  <section className="relative overflow-hidden">
    <img src={IMG.hero} alt="Hospital corridor background" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-primary/95" />
    <div className="container-main py-12 sm:py-20 relative z-10 grid lg:grid-cols-2 gap-8 sm:gap-10 items-center">
      <div className="min-w-0">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-2 sm:mb-3">Stay Updated</h2>
        <p className="text-white/60 max-w-md leading-relaxed text-base sm:text-lg">Subscribe to get the latest medical product news, promotions and healthcare updates delivered to your inbox.</p>
      </div>
      <form className="flex flex-col sm:flex-row gap-3 w-full min-w-0" onSubmit={e => e.preventDefault()}>
        <input type="email" placeholder="Enter your email address"
          className="flex-1 min-w-0 px-4 sm:px-5 py-3.5 sm:py-4 rounded-xl text-sm outline-none text-gray-700 focus:ring-2 focus:ring-accent shadow-xl" />
        <button type="submit" className="inline-flex items-center justify-center gap-2 bg-white text-primary font-extrabold px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl hover:bg-gray-50 transition-colors shadow-xl whitespace-nowrap min-h-[48px]">
          Subscribe <SendIcon fontSize="small" />
        </button>
      </form>
    </div>
  </section>
);

export default HomeNewsletter;
